import util from '@/utils/util';
// console.log('8888888888888888',util);

export const publicData = {
  // logo:require("@/assets/img/logo.png"),
  projectName: '支付页面',
  getComArgs:
    process.env.NODE_ENV === 'development' || util.getUrlQueryString('testId')
      ? // process.env.NODE_ENV === "development"
        'token=125&udid=125&productId=' +
        '97a6cfac-8493-41f0-8d89-8f8411372419' +
        '&vestId=' +
        'edff7262-d98e-4def-bcd8-db7139d81f74' +
        '&channel=test8&osType=android&version=1'
      : '',
payList: [
    {
      payMode: "alipay",
      payType: 1, // 新增
      supportFlag: true,
      defaultPayFlag: false,
    },
    {
      payMode: "weChat",
      payType: 2, // 新增
      supportFlag: true,
      defaultPayFlag: true,
    },
  ],
  // payList: [
  //   {
  //     payMode: "alipay",
  //     payType: 1, // 新增
  //     supportFlag: true,
  //     defaultPayFlag: true,
  //   },
  //   {
  //     payMode: "weChat",
  //     payType: 2, // 新增
  //     supportFlag: false,
  //     defaultPayFlag: false,
  //   },
  // ],
};
